import React from 'react';
import { Form, Button, } from 'react-bootstrap';
import moment from 'moment';
import CustomerService from '../../../service/CustomerService';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import store from '../../../store';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../modules/Constants';

class LinkedCustomersView extends React.Component {
  constructor(props) {
    super(props);

    this.handlePrimaryCustomerIdChange = this.handlePrimaryCustomerIdChange.bind(this);
    this.handleSecondaryCustomerIdChange = this.handleSecondaryCustomerIdChange.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.viewLinkedCustomers = this.viewLinkedCustomers.bind(this);
    this.viewLinkedCustomersHistory = this.viewLinkedCustomersHistory.bind(this);
    this.link = this.link.bind(this);
    this.unlink = this.unlink.bind(this);

    this.state = {
      headers: [],
      rows: [],
      primaryCustomerId: '',
      secondaryCustomerId: '',
      reason: '',
    };
  }

  handlePrimaryCustomerIdChange(e) {
    this.setState({ primaryCustomerId: e.target.value, });
  }

  handleSecondaryCustomerIdChange(e) {
    this.setState({ secondaryCustomerId: e.target.value, });
  }

  handleReasonChange(e) {
    this.setState({ reason: e.target.value, });
  }

  viewLinkedCustomers(event) {
    this.resetTable();
    event.preventDefault();
    const { primaryCustomerId, } = this.state;
    const rows = [];
    const headers = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'linkedCustomerIds',
        display: 'Linked Customer Ids',
      },
    ];

    CustomerService.getLinkedCustomers(primaryCustomerId)
      .then((response) => {
        const { links, } = response.data;
        if (response.status === 200) {
          rows.push({
            value: [
              links.customerId,
              links.linkedCustomerIds,
            ],
            raw: links,
          });
        }
        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
      });
  }

  viewLinkedCustomersHistory(event) {
    this.resetTable();
    event.preventDefault();
    const { primaryCustomerId, } = this.state;
    const rows = [];
    const headers = [
      {
        value: 'customerIdLinked',
        display: 'Customer Id Linked',
      },
      {
        value: 'linkDate',
        display: 'Link Date',
      },
      {
        value: 'linkAction',
        display: 'Link Action',
      },
      {
        value: 'linkReason',
        display: 'Link Reason',
      },
      {
        value: 'athosUserId',
        display: 'Athos User Id',
      },
    ];

    CustomerService.getLinkedCustomersHistory(primaryCustomerId)
      .then((response) => {
        const { history, } = response.data;
        if (history && history.length > 0) {
          history.forEach((historyItem) => {
            rows.push({
              value: [
                historyItem.customerIdLinked,
                historyItem.linkDate ? moment(historyItem.linkDate * 1000).utc().format() : '',
                historyItem.linkAction,
                historyItem.reason,
                historyItem.athosUserId,
              ],
              raw: historyItem,
            });
          });
        }
        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
      });
  }

  link(event) {
    this.resetTable();
    event.preventDefault();
    const { primaryCustomerId, secondaryCustomerId, reason, } = this.state;
    const { authentication, } = store.getState().auth;
    const athosUserId = authentication.tenantUserId;
    const rows = [];
    const headers = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'linkedCustomerIds',
        display: 'Linked Customer Ids',
      },
    ];

    CustomerService.linkCustomers(primaryCustomerId, secondaryCustomerId, athosUserId, reason)
      .then((response) => {
        const { links, } = response.data;
        if (response.status === 200) {
          rows.push({
            value: [
              links.customerId,
              links.linkedCustomerIds,
            ],
            raw: links,
          });
        }
        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
      });
  }

  unlink(event) {
    this.resetTable();
    event.preventDefault();
    const { primaryCustomerId, secondaryCustomerId, reason, } = this.state;
    const { authentication, } = store.getState().auth;
    const athosUserId = authentication.tenantUserId;
    const rows = [];
    const headers = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'linkedCustomerIds',
        display: 'Linked Customer Ids',
      },
    ];

    CustomerService.unlinkCustomers(primaryCustomerId, secondaryCustomerId, athosUserId, reason)
      .then((response) => {
        const { links, } = response.data;
        if (response.status === 200) {
          rows.push({
            value: [
              links.customerId,
              links.linkedCustomerIds,
            ],
            raw: links,
          });
        }
        this.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
      });
  }

  reset() {
    this.setState({
      headers: [],
      rows: [],
      primaryCustomerId: '',
      secondaryCustomerId: '',
      reason: '',
    });
  }

  resetTable() {
    this.setState({
      headers: [],
      rows: [],
    });
  }

  render() {
    const {
      headers = [], rows = [], primaryCustomerId, secondaryCustomerId, reason,
    } = this.state;
    const style = {
      maxHeight: '500px',
    };

    return (
      <div className="container">
        <hr />
        <p>Linking these customers will make all payment history and documents from both accounts
          available to the primary customer. Connected accounts and payables will not be linked and users
          will need to manually connect any accounts or payables. Payment accounts are not shared between accounts.
        </p>
        <hr />
        <Form className="p-5">
          <Form.Group className="mb-3">
            <h3>Customer ID</h3>
            <Form.Control
              type="text"
              placeholder="Enter primary customerId"
              value={primaryCustomerId}
              onChange={this.handlePrimaryCustomerIdChange}
            />
            <hr />

            <h5>Link or Unlink Customers</h5>
            <Form.Control
              type="text"
              placeholder="Enter customerId to be linked or unlinked"
              value={secondaryCustomerId}
              onChange={this.handleSecondaryCustomerIdChange}
            />
            <Form.Control
              type="text"
              placeholder="(Optional) Enter reason to be linked or unlinked"
              value={reason}
              onChange={this.handleReasonChange}
            />
          </Form.Group>
          <Button className="me-2" variant="primary" type="submit" onClick={this.viewLinkedCustomers}>
            View Linked Customers
          </Button>
          <Button className="me-2" variant="primary" type="submit" onClick={this.link}>
            Link Customers
          </Button>
          <Button className="me-2" variant="primary" type="submit" onClick={this.unlink}>
            Unlink Customers
          </Button>
          <Button className="me-2" variant="primary" type="submit" onClick={this.viewLinkedCustomersHistory}>
            Get Linked Customers History
          </Button>
        </Form>
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Linked Customers Data" style={style}>
            <Grid
              headers={headers}
              rows={rows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

export default LinkedCustomersView;
